import { render } from "./Kanban.vue?vue&type=template&id=445ef3ee&ts=true"
import script from "./Kanban.vue?vue&type=script&lang=ts"
export * from "./Kanban.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__